/* eslint-disable @stylistic/brace-style */
/* eslint-disable @stylistic/semi */
import { LocationGlobeIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import type { WithDataTestid } from '@vlabs/uikit/types';
import i18next from 'i18next';

import type { NamedOption } from './utils';
import { getCurrentOption, getNextOption } from './utils';
import { buildTestid } from '../../../lib/utils';
import { navbarPanelTranslation } from '../i18n';

interface LanguageOption extends NamedOption {
  label: string;
  icon: React.ReactElement;
}

export const defaultLanguageOptions: LanguageOption[] = [
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  { value: 'ru', icon: <LocationGlobeIcon />, get label() { return navbarPanelTranslation('language_ru') } },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  { value: 'en', icon: <LocationGlobeIcon />, get label() { return navbarPanelTranslation('language_en') } },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  { value: 'ptBr', icon: <LocationGlobeIcon />, get label() { return navbarPanelTranslation('language_ptBr') } },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  { value: 'esEs', icon: <LocationGlobeIcon />, get label() { return navbarPanelTranslation('language_esEs') } },
];

export interface LanguageButtonProps extends
  WithDataTestid,
  Omit<IconButtonProps, 'onClick'> {
  languageOptions?: LanguageOption[];
}

const displayName = 'LanguageButton';
const testid = buildTestid(displayName);

function LanguageButton({
  languageOptions = defaultLanguageOptions,
  'data-testid': dataTestId = undefined,
  ...props
}: LanguageButtonProps): React.JSX.Element {
  const nextLanguage = getNextOption(i18next.language, languageOptions);
  const { option: currentLanguageOption } = getCurrentOption(i18next.language, languageOptions);

  return (
    <IconButton
      icon={currentLanguageOption?.icon ?? <LocationGlobeIcon />}
      kind="secondary"
      onClick={async () => i18next.changeLanguage(nextLanguage.value)}
      shape="square"
      title={currentLanguageOption?.label ?? i18next.language}
      variant="dimmed"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

LanguageButton.displayName = displayName;

export { LanguageButton };
